// Imports
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".recharts-cartesian-grid-horizontal > line { display: none }", "",{"version":3,"sources":["webpack://src/index.css"],"names":[],"mappings":"AAAA,6CAA6C,cAAc","sourcesContent":[".recharts-cartesian-grid-horizontal > line { display: none }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
